<checkout-account-new [content]="content"
                      [(showSubscriptionOptIn)]="showSubscriptionOptIn"
                      (showSubscriptionOptInChange)="showSubscriptionOptInChange.emit($event)" />